import type { Address } from '~/common/types/location';

export const isAddressValid = (addressValues?: Address): boolean => {
  if (!addressValues) {
    return false;
  }

  const { lat, lng, postcode, stateName, suburb } = addressValues;

  return !!lat && !!lng && !!postcode && !!stateName && !!suburb;
};
